import React from 'react';
import { ConfirmContent, ConfirmText, ConfirmWrapper, FilledButton, HollowButton, SecondText } from './styles';
import { FlexBox } from '@brg/ui';
export var TemplateModal = function (_a) {
    var mainText = _a.mainText, confirmText = _a.confirmText, secondText = _a.secondText, cancelText = _a.cancelText, onConfirm = _a.onConfirm, onSecond = _a.onSecond;
    return (React.createElement(ConfirmWrapper, null,
        React.createElement(ConfirmContent, null,
            React.createElement(FlexBox, { direction: 'column', directionMobile: 'column', gy: 8, gyMobile: 8 },
                React.createElement(ConfirmText, null, mainText),
                React.createElement(SecondText, null, secondText)),
            React.createElement(FlexBox, { width: '100%', widthMobile: '100%', gx: 24, gxMobile: 1, gyMobile: 8, direction: 'row', directionMobile: 'column', offsetTop: 24, justify: 'center' },
                React.createElement(HollowButton, { onClick: onSecond }, cancelText),
                React.createElement(FilledButton, { onClick: onConfirm }, confirmText)))));
};
//# sourceMappingURL=TemplateModal.js.mapimport React from 'react';
import { ConfirmContent, ConfirmText, ConfirmWrapper, FilledButton, HollowButton, SecondText } from './styles';
import { FlexBox } from '@brg/ui';
export var TemplateModal = function (_a) {
    var mainText = _a.mainText, confirmText = _a.confirmText, secondText = _a.secondText, cancelText = _a.cancelText, onConfirm = _a.onConfirm, onSecond = _a.onSecond;
    return (React.createElement(ConfirmWrapper, null,
        React.createElement(ConfirmContent, null,
            React.createElement(FlexBox, { direction: 'column', directionMobile: 'column', gy: 8, gyMobile: 8 },
                React.createElement(ConfirmText, null, mainText),
                React.createElement(SecondText, null, secondText)),
            React.createElement(FlexBox, { width: '100%', widthMobile: '100%', gx: 24, gxMobile: 1, gyMobile: 8, direction: 'row', directionMobile: 'column', offsetTop: 24, justify: 'center' },
                React.createElement(HollowButton, { onClick: onSecond }, cancelText),
                React.createElement(FilledButton, { onClick: onConfirm }, confirmText)))));
};
//# sourceMappingURL=TemplateModal.js.map